<template>
    
    <ContentWrapper>
        <SectionHeader subheader="Subheader" title="Section Title about the Section and How it Works" />

        <div class="flex flex-col md:flex-row gap-4 mt-18">
            <div class="rounded rounded-tl-4xl bg-gray-100 p-4 md:w-1/3 h-128">
               
            </div>

            <div class="md:w-1/3 h-128">
               <div class="flex flex-col gap-4 h-full">
                <div class="bg-gray-100 p-4 h-1/2">
                   
                </div>

                <div class="bg-gray-100 p-4 h-1/2">
                   
                </div>
               </div>
            </div>

            <div class="rounded rounded-br-4xl bg-gray-100 p-4 md:w-1/3 h-128">

            </div>
        </div>


    </ContentWrapper>
</template>

<script setup>

import ContentWrapper from '../Layouts/ContentWrapper.vue'
import SectionHeader from '../Layouts/SectionHeader.vue'

</script>
